import React from 'react';

export default function Spinner() {
  return (
    <div className="min-h-50vh flex items-center justify-center">
      <div className="h-32 w-32 animate-spin rounded-full border-b-4 border-t-4 border-text-accent" />
    </div>
  );
}
